import { IApplicationState } from '../../../types/redux';

/**
 * Показано ли сообщение, запрещающее b2b режим
 */
export const isB2BForbiddingMessageShownSelect = ({ userNew }: IApplicationState) =>
  userNew.isB2BForbiddingMessageShown;
